<div class="wrapper-feedback-list">

    <div class="section-title row">
        <div class="section-btn">
            <button routerLink='/dashboard/faq' class="btn btn-back" [attr.aria-label]="'Back' | translate">
              <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <div>
            <div class="title" [attr.data-parent]="'Help Center' | translate">{{'Feedback' |translate}}</div>
        </div>
        <div class="form-group">
            <div class="d-inline-block w-100">
                <button routerLink='/dashboard/e-ticketing-form' class="btn btn-blue">{{'Create Feedback' |translate}}</button>
            </div>
        </div>
    </div>
	
	<div class="row">
		<div class="col-md-10">
			<div class="alert alert-info my-2 mt-2" role="alert">
				{{'Your feedback is valuable to us, as we work to improve both our products and our services to you. If you have any suggestions or recommendations, please feel free to submit them through the feedback form.' |translate}}
			</div>
		</div>
	</div>
	

    <div class="section-main">
        <div class="table-history table-responsive mx-auto">
            <table class="table">
                <thead>
                    <tr>
                        <th class="border-left-0 text-start" scope="col">
                            {{'Topic' |translate}}
                        </th>
                        <th class="border-left-0 text-start" scope="col">
                            {{'Message' |translate}}
                        </th>
                        <!--th class="border-left-0 text-start" scope="col">
                            Photo
                        </th-->
                        <th class="border-left-0 text-center" scope="col">
                            {{'Time Created' |translate}}
                        </th>
                        <th class="border-right-0 text-center" scope="col">
                            {{'Status' |translate}}
                        </th>
                        <th class="border-right-0 text-center" scope="col">
                            {{'Action' |translate}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="feedbackList.length == 0 && !loading">
                        <td colspan="8" class="border-left-0 border-right-0 pb-4 text-center no-records">{{'No Record found' |translate}}
                        </td>
                    </tr>
                    <tr *ngIf="loading">
                        <td class="border-left-0 border-right-0 pb-4 text-center" colspan="8">
                            <div class="loading-spinner col-12">
                                <mat-spinner
                                  class="mx-auto my-3"
                                  [diameter]="50"
                                ></mat-spinner>
                              </div>
                        </td>
                    </tr>
                    <tr *ngFor="let data of feedbackList; let index=index">
                        <td class="border-left-0 text-start">{{ '{0}' | translate:[ utils.translate(data.topic_info.topic)] }}</td>
                        <td class="text-start">
                          {{data.message}}
                          <ng-container *ngIf="data.photo && data.photo != 'No Image'">
                            <br><a [href]="data.photo" target="_blank">{{'View Image' |translate}}</a>
                          </ng-container>
                        </td>
                        <!--td class="text-center">
                            <div class="row">
                                <div class="col text-center">
                                    <img height="120px" src="{{data.photo}}" alt="">
                                </div>
                            </div>
                        </td-->
                        <td class="text-center">{{data.created_at | date:'medium' }}</td>
                        <td class="border-right-0 text-center">
                            {{ '{0}' | translate:[ utils.translate(data.status=='1' ? 'Active' : 'Inactive')] }}
                        </td>
                        <td class="border-right-0 text-center">
                            <button mat-button class="btn btn-action --single"
                                (click)="goFeedbackFormPage(data.feedback_id)"
                                routerLinkActive="link-active">{{'View' |translate}}</button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>
<div *ngIf="feedbackList.length != 0 && !loading" class="row px-4 py-3 pagination">
    <div class="col-md-12 col-lg-4">
        <ngb-pagination [collectionSize]="feedback.length" [(page)]="page" [pageSize]="selectedPage"
            aria-label="Default pagination" (pageChange)="changePage($event)"></ngb-pagination>
    </div>
    <div class="col-md-12 col-lg-4 lg-center">
        <div class="mt-2 text-center">{{ "Showing" | translate }} <b>{{ start + 1 }}–{{ end }}</b> {{ "of" | translate }} <b>{{ feedback.length }}</b> </div>
    </div>
    <div class="col-md-12 col-lg-4 lg-end">
        <div class="m-0 mt-2 text-center">
            <div>{{ "Per page:" | translate }}
                <span>
                    <div ngbDropdown class="d-inline-block">
                        <button class="btn btn-blue-small btn-page" id="dropdownBasic1" ngbDropdownToggle>{{
                            selectedPage }}</button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button ngbDropdownItem (click)="selectPage(10)">10</button>
                            <button ngbDropdownItem (click)="selectPage(20)">20</button>
                            <button ngbDropdownItem (click)="selectPage(30)">30</button>
                        </div>
                    </div>
                </span>
            </div>


        </div>
    </div>
</div>
